import { render } from "./EventList.vue?vue&type=template&id=f79379be&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=f79379be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f79379be"

export default script